import { Field, FieldValidator, FormikHelpers } from 'formik';

import React from 'react';
import Button from '../Button';
import useClasses from '../../hooks/useClasses';

import './style.scss';

interface Props<T extends object = {}> {
  fieldName: string
  validation?: FieldValidator
  title?: string
  value?: string
  error?: string
  hideTitle?: boolean
  options: {
    [Property in keyof T]: string
  }
}

const SwitchButtons: React.FC<Props> = <T extends object = {}>({
  fieldName,
  validation,
  value,
  title,
  error,
  hideTitle,
  options,
}: Props<T>) => {
  const { buildClass, joinClasses } = useClasses('SwitchButtons');

  const optionKeys = Object.keys(options) as (keyof T)[];

  return (
    <Field
      name={fieldName}
      validation={validation}
    >
      {(formik: { form: FormikHelpers<any> }) => (
        <div className={buildClass()}>
          {title && (
          <span
            id={`label-${fieldName}`}
            className={joinClasses(buildClass('label'), {
              'sr-only': hideTitle,
            })}
          >{title}
          </span>
          )}
          {error && (
            <span className={joinClasses('FormElement__error', buildClass('error-message'))}>
              {error}
            </span>
          )}
          <div
            className={buildClass('button-container')}
            role="radiogroup"
            {...title ? {
              'aria-labelledby': `label-${fieldName}`,
            } : {}}
          >
            {optionKeys.map((optionKey) => (
              <Button
                secondary
                key={optionKey as string}
                onClick={() => formik.form.setFieldValue(fieldName, optionKey)}
                buttonState={value === optionKey && 'active'}
                role="radio"
                aria-checked={value === optionKey}
              >
                {options[optionKey]}
              </Button>
            ))}
          </div>
        </div>
      )}
    </Field>
  );
};

export default SwitchButtons;
